import React from 'react';
import { Home, Bed, Bath, MoreVertical } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from './ui/dropdown-menu';
import AddressVerificationBadge from './AddressVerificationBadge';

const PropertyCard = ({ property, onEdit, onDelete, formatDate }) => {
  return (
    <div className="bg-white rounded-lg border border-[#E2E8F0] p-6 hover:shadow-md transition-shadow relative">
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 rounded-lg bg-[#F1F5F9] flex items-center justify-center">
            <Home className="w-6 h-6 text-[#16A34A]" />
          </div>
          <div>
            <h3 className="text-[#030712] font-medium mb-1">{property.name}</h3>
            <p className="text-sm text-[#64748B]">{property.address}</p>
            <div className="mt-1">
              <AddressVerificationBadge
                verified={property.address_verified}
                verdict={property.address_validation_verdict}
              />
            </div>
          </div>
        </div>

        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <button className="p-1 hover:bg-[#F1F5F9] rounded transition-colors">
              <MoreVertical className="w-5 h-5 text-[#64748B]" />
            </button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <DropdownMenuItem onClick={() => onEdit(property)}>
              Edit
            </DropdownMenuItem>
            <DropdownMenuItem
              className="text-[#EF4444] focus:text-[#EF4444] focus:bg-[#FEF2F2]"
              onClick={() => onDelete(property)}
            >
              Delete
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>

      <div className="flex items-center gap-4 mb-4 text-sm text-[#64748B]">
        <div className="flex items-center gap-1.5">
          <Bed className="w-4 h-4" />
          <span>{property.bedrooms ?? 0} bed</span>
        </div>
        <div className="flex items-center gap-1.5">
          <Bath className="w-4 h-4" />
          <span>{property.bathrooms ?? 0} bath</span>
        </div>
        {property.property_type && (
          <span>{property.property_type}</span>
        )}
      </div>

      {property.description && (
        <div className="pt-4 border-t border-[#E2E8F0]">
          <p className="text-sm text-[#64748B]">{property.description}</p>
        </div>
      )}

      <div className="mt-4 pt-4 border-t border-[#E2E8F0]">
        <p className="text-xs text-[#64748B]">Added {formatDate(property.date_added)}</p>
      </div>
    </div>
  );
};

export default PropertyCard;
